import React, { useState, useMemo } from 'react';
import { getListId } from '@alltrails/shared/utils/listHelpers';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import SearchInsightsProvider from 'components/SearchInsightsProvider';
import useListItems from '../../hooks/useListItems';
import { FullscreenSearchApp } from '../../application/javascripts/react_components/search/fullscreen/search_app';
import { EXPLORE } from '../../utils/constants/SearchAnalyticsConstants';

const listAccessForAdminOrCurrentUser = ({ context, userInfo }, page) => {
  if (context.adminUser && page === PageStrings.EXPLORE_COMPLETED_PAGE) {
    return true;
  }

  return userInfo && context && context.currentUser && context.currentUser.id == userInfo.id;
};

const SearchApp = props => {
  const [page, setPage] = useState(props.initialPage || PageStrings.EXPLORE_ALL_PAGE);
  const listId = useMemo(() => getListId(page, props.initialCustomList), [page, props.initialCustomList]);
  const belongsToCurrentUser = listAccessForAdminOrCurrentUser(props, page);
  const { listMethods, renderModal, listItems, lists, latestListAction, userListItems } = useListItems(
    {
      lists: props.initialMyLists,
      listItems: props.initialMyListItems,
      userListItems: props.initialUserListItems,
      belongsToCurrentUser: belongsToCurrentUser && listId // this decides whether or not to edit an individual users list
    },
    props.context,
    page
  );

  const updatePage = newPage => {
    setPage(newPage);
  };

  return (
    <SearchInsightsProvider context={props.context} pageName={EXPLORE}>
      {renderModal()}
      <FullscreenSearchApp
        {...props}
        latestListAction={latestListAction}
        lists={lists}
        listItems={listItems}
        userListItems={userListItems}
        listMethods={listMethods}
        listId={listId}
        belongsToCurrentUser={belongsToCurrentUser}
        updatePage={updatePage}
      />
    </SearchInsightsProvider>
  );
};

export default SearchApp;
